"use client"

import Image from "next/image"
import {
  hideForDesktop,
  itemListTitle,
  toggleButtonContentContainer,
} from "../Header/Menu/styles.css"
import { ChevronRightIcon } from "../../SVG"
import React, { useEffect } from "react"
import { ExperimentFlags } from "@shared/utils.experimentation"
import { trackExperimentViewed } from "../../../tracking/hooks/useExperimentViewed"
import { NotificationBadge } from "../../../packages/membership/components/NotificationBadge"
import {
  useTrackElementClicked,
  useTrackElementViewed,
} from "packages/membership/tracking"
import { useRouter } from "../../../lib/router"
import { useUser } from "../../../lib/user"

type MenuItem = {
  id: string
  image:
    | undefined
    | {
        src: string
        description: string
      }
  title: string
  href: string
}

type Props = {
  recursionCount: number
  item: MenuItem
  showNotification?: boolean
}

const baseTrackingValues = {
  target: "order_it_again",
  location: "navigation",
}

export function OrderItAgain({
  recursionCount,
  item,
  showNotification,
}: Props) {
  const { ref } = useTrackElementViewed({ ...baseTrackingValues })
  const { elementClicked } = useTrackElementClicked({ ...baseTrackingValues })
  const [notificationClicked, setNotificationClicked] =
    React.useState<boolean>(true)
  const router = useRouter()

  const isOrderItAgainPage = router.pathname.includes(
    "/account/favourites/order-it-again"
  )
  const { isMember } = useUser()

  useEffect(() => {
    setNotificationClicked(!!localStorage.getItem("HIGHLIGHTED_NAV_ITEM"))
    trackExperimentViewed(
      ExperimentFlags.PAGE_EXPERIMENT_HIGHLIGHT_NAV_ITEM,
      showNotification ? 1 : 0
    )
  }, [showNotification])

  return (
    <>
      <a
        ref={ref}
        href={item.href}
        track-click={`Nav${recursionCount + 1}`}
        onClick={() => {
          elementClicked({
            details: "order_it_again_link",
          })
        }}
      >
        {item.image ? (
          <>
            <Image
              src={item.image.src}
              alt={item.image.description}
              width={256}
              height={256}
            />
            <span
              className={`${toggleButtonContentContainer} ${itemListTitle}`}
            >
              <span className="text">{item.title}</span>
              <ChevronRightIcon className={hideForDesktop} />
            </span>
          </>
        ) : (
          <span className="text">{item.title}</span>
        )}
      </a>{" "}
      {showNotification &&
        !notificationClicked &&
        !isOrderItAgainPage &&
        isMember && <NotificationBadge text="New" />}
    </>
  )
}
